import React from 'react';

import {
  Cell,
  Table,
  TableHeader,
  THead,
  Row,
} from '../../../components/table/styled-shared-table';

import styles from './additional-info-table.module.scss';
type AdditionalInfoTableProps = {
  additionalInfo: AdditionalInfo[];
};

export type AdditionalInfo = {
  number: number;
  props?: string;
  directorsNote?: string;
};

export const AdditionalInfoTable: React.FC<AdditionalInfoTableProps> = ({ additionalInfo }) => (
  <Table>
    <col
      style={{
        width: '8%',
      }}
    />

    <col
      style={{
        width: '42%',
      }}
    />

    <col
      style={{
        width: '50%',
      }}
    />

    <TableHeader>
      <THead className={styles['table-head-cell']}>Shot number</THead>

      <THead className={styles['table-head-cell']}>Props</THead>

      <THead className={styles['table-head-cell']}>Director&apos;s notes</THead>
    </TableHeader>

    <tbody>
      {additionalInfo.map((info) => (
        <Row key={info.number}>
          <Cell className={styles['table-cell']}>{info.number}</Cell>
          <Cell className={styles['table-cell']}>{info.props || ''}</Cell>
          <Cell className={styles['table-cell']}>{info.directorsNote || ''}</Cell>
        </Row>
      ))}
    </tbody>
  </Table>
);
